import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB0PSIxNzQ0NjAyMzQzOTgwIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjExMDU5IiB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgc3R5bGU9ImJhY2tncm91bmQ6I2ZmZiI+PHBhdGggZD0iTTk2IDY0aDgzMmEzMiAzMiAwIDEgMSAwIDY0aC04MzJhMzIgMzIgMCAwIDEgMC02NHogbTQ0OCAzODRoMzg0YTMyIDMyIDAgMSAxIDAgNjRoLTM4NGEzMiAzMiAwIDAgMSAwLTY0eiBtLTQxMC4zNjggNDYuNDY0bDI1OC40MzIgMTcyLjI4OGE0NC44IDQ0LjggMCAwIDEgMCA3NC40OTZsLTI1OC40MzIgMTcyLjI4OEE0NC44IDQ0LjggMCAwIDEgNjQgODc2LjI4OFY1MzEuNzEyYTQ0LjggNDQuOCAwIDAgMSA2OS42MzItMzcuMjQ4ek01NDQgODMyaDM4NGEzMiAzMiAwIDEgMSAwIDY0aC0zODRhMzIgMzIgMCAxIDEgMC02NHoiIHAtaWQ9IjExMDYwIj48L3BhdGg+PC9zdmc+)
 */
export const MenuOpenIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16, ...props }, forwardedRef) => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M96 64h832a32 32 0 1 1 0 64h-832a32 32 0 0 1 0-64z m448 384h384a32 32 0 1 1 0 64h-384a32 32 0 0 1 0-64z m-410.368 46.464l258.432 172.288a44.8 44.8 0 0 1 0 74.496l-258.432 172.288A44.8 44.8 0 0 1 64 876.288V531.712a44.8 44.8 0 0 1 69.632-37.248zM544 832h384a32 32 0 1 1 0 64h-384a32 32 0 1 1 0-64z"
          fill={color}
        ></path>
      </svg>
    )
  },
)
